import React, { DetailedHTMLProps, InputHTMLAttributes } from "react";

import classnames from "classnames";

type CardBodyProps = DetailedHTMLProps<
  InputHTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>;

const CardBody: React.FC<CardBodyProps> = ({
  children,
  className,
  ...props
}) => {
  const cardBodyStyle = classnames(
    "px-4 py-5 text-sm leading-5 sm:px-6 text-dark-100",
    className
  );

  return (
    <div className={cardBodyStyle} {...props}>
      {children}
    </div>
  );
};

export default React.memo(CardBody);
